// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Recipes-ActionBar-__ActionBar___3-D9d","btn-outlet":"app-pages-Ingredient-Recipes-ActionBar-__ActionBar___vXuoC","action-bar":"app-pages-Ingredient-Recipes-ActionBar-__ActionBar___Iuheu"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Ingredient/Recipes/ActionBar/ActionBar.css
// module id = 2363
// module chunks = 0